module.exports = __webpack_public_path__ + "static/media/employee.73fdcb51.jpg";